import clsx from "clsx";
import React from "react";
import TabsModalFooter from "ui/common/components/feedback/TabsModal/TabsModalFooter/TabsModalFooter";
import useGoToNextTab from "ui/common/components/feedback/TabsModal/hooks/useGoToNextTab";
import useSetTabsState from "ui/common/components/feedback/TabsModal/hooks/useSetTabsState";
import DocumentUpload from "ui/common/components/input/DocumentUpload/DocumentUpload";
import Form from "ui/common/components/input/Form/Form";
import useTranslate from "ui/locale/hooks/useTranslate";
import { UpdateTermsAndPrivacyName, UpdateTermsAndPrivacyState } from "./UpdateTermsAndPrivacyModal.types";

export interface UploadTermsAndPrivacyTabProps {
    className?: string;
    style?: React.CSSProperties;
}

export interface updateTermsAndConditions {
    privacyPolicy: File | undefined;
    personalDataTreatmentAuthorization: File | undefined;
    termsAndConditions: File | undefined;
}

export default function UploadTermsAndPrivacyTab({ className, ...rest }: UploadTermsAndPrivacyTabProps) {
    const translate = useTranslate();
    const setTabsState = useSetTabsState<UpdateTermsAndPrivacyState>();
    const goToNextTab = useGoToNextTab();

    async function handleSubmit(data: updateTermsAndConditions) { // skipcq: JS-0116
        setTabsState(data);
        goToNextTab();
    }

    return (
        <Form className={clsx("upload-terms-privacy-tab", className)} onSubmit={handleSubmit} {...rest}>
            <DocumentUpload name={UpdateTermsAndPrivacyName.TERMS} label={translate("termsAndConditions")} fileTypes=".pdf" />
            <DocumentUpload name={UpdateTermsAndPrivacyName.PERSONAL_DATA_TREATMENT} label={translate("personalDataTreatmentAuthorization")} fileTypes=".pdf" />
            <DocumentUpload name={UpdateTermsAndPrivacyName.PRIVACY} label={translate("privacyPolicy")} fileTypes=".pdf" />
            <TabsModalFooter mainType="submit" />
        </Form>
    );
}
